import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/farm-story/components/FarmStoryInteractive.tsx");
